import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import { useFormik } from "formik";
import * as Yup from "yup";
import { Editor } from '@tinymce/tinymce-react';
import { CompanyService } from "../../../services/user/company.services";
import { useSelector } from "react-redux";
import { CURRENCY_ENUM } from "../../../utility";
import { CountryService } from "../../../services/user/country.services";
import { StateService } from "../../../services/user/state.services";
import { handleNotify, TOASTER_POSITION, TOASTER_TYPE } from "../../common/notification/toaster_notify.component";
import striptags from "striptags";
import Select from 'react-select';

const CompanyComponent = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const companyId = location.state?.user.companyId;
    const [selectedFaviconImage, setSelectedFaviconImage] = useState(null);
    const [selectedLogoImage, setSelectedLogoImage] = useState(null);
    const [previewFaviconUrl, setPreviewFaviconUrl] = useState(null);
    const [previewLogoUrl, setPreviewLogoUrl] = useState(null);
    const selectedStore = location.state?.user.selectedStoreId;
    const [countries, setCountries] = useState([]);
    const [states, setStates] = useState([]);

    const formik = useFormik({
        initialValues: {
            companyName: "",
            GSTNo: "",
            email: "",
            website: "",
            panCard: "",
            phoneNumber: "",
            mobile: "",
            billingAddressLine1: "",
            billingCity: "",
            billingStateId: 0,
            billingPincode: "",
            billingCountryId: 0,
            billingCurrencyId: CURRENCY_ENUM[0].currencyId,
            shippingAddressLine1: "",
            shippingCity: "",
            shippingStateId: 0,
            shippingPincode: "",
            shippingCountryId: 0,
            shippingCurrencyId: CURRENCY_ENUM[0].currencyId,
            aboutCompany: "",
            favicon: null,
            faviconfilename: "",
            logo: null,
            logofilename: ""
        },

        validationSchema: Yup.object({
            companyName: Yup.string().required("Company Name is Required"),
            phoneNumber: Yup.string().required("Phone Number is Required"),
            billingPincode: Yup.string().required("Pincode is Required"),
            billingAddressLine1: Yup.string().required("Address is Required"),
            shippingPincode: Yup.string().required("Pincode is Required"),
            shippingAddressLine1: Yup.string().required("Address is Required"),
        }),
        onSubmit: async (values, { resetForm }) => {
            const cleanedAboutCompany = striptags(values.aboutCompany);
            try {
                // debugger
                const updatedValues = {
                    ...values,
                    favicon: values.favicon,
                    faviconfilename: values.faviconfilename,
                    logo: values.logo,
                    logofilename: values.logofilename,
                    aboutCompany: cleanedAboutCompany,
                    billingCurrencyId: values.billingCurrencyId,
                    shippingCurrencyId: values.shippingCurrencyId,
                    billingAddressLine1: values.billingAddressLine1,
                    billingCountryId: parseInt(values.billingCountryId),
                    billingStateId: parseInt(values.billingStateId),
                    billingPincode: parseInt(values.billingPincode),
                    billingCurrencyId: parseInt(values.billingCurrencyId),
                    shippingCountryId: parseInt(values.shippingCountryId),
                    shippingStateId: parseInt(values.shippingStateId),
                    shippingPincode: parseInt(values.shippingPincode),
                    shippingCurrencyId: parseInt(values.shippingCurrencyId),
                    shippingAddressLine1: values.shippingAddressLine1
                }
                await CompanyService.addNewCompany(updatedValues)
                    .then(response => {
                        if (response) {
                            navigate('/dashboard')
                        }
                    })
                resetForm();
            }
            catch (error) {
                handleNotify('Error while add new company', TOASTER_TYPE.ERROR, TOASTER_POSITION.TOP_RIGHT)
            }
        },
    });

    const fetchCountry = async () => {
        try {
            const response = await CountryService.getAllCountry(selectedStore);
            if (response) {
                const sortedCountry = response.sort((a, b) => a.countryId - b.countryId);
                //formik.setFieldValue("shippingCountryId", sortedCountry?.[0]?.countryId);
                //formik.setFieldValue("billingCountryId", sortedCountry?.[0]?.countryId);
                const countryIdOptions = sortedCountry.map(country => ({
                    value: country.countryId,
                    label: country.countryName,
                }));
                if (!formik.values.billingCountryId && countryIdOptions.length > 0) {
                    formik.setFieldValue("billingCountryId", countryIdOptions[0].value);
                }
                if (!formik.values.shippingCountryId && countryIdOptions.length > 0) {
                    formik.setFieldValue("shippingCountryId", countryIdOptions[0].value);
                }
                setCountries(countryIdOptions);
            }
            else {
                setCountries([]);
            }
        } catch (error) {
            handleNotify("Error fetching countries:", error, TOASTER_TYPE.ERROR, TOASTER_POSITION.TOP_RIGHT)
        }
    };

    const fetchStates = async () => {
        try {
            const response = await StateService.getAllStates(selectedStore);
            if (response) {
                const sortedState = response.sort((a, b) => a.stateId - b.stateId);
                const stateOptions = sortedState.map(state => ({
                    value: state.stateId,
                    label: state.stateName,
                }));
                if (!formik.values.billingStateId && stateOptions.length > 0) {
                    formik.setFieldValue("billingStateId", stateOptions[0].value);
                }
                if (!formik.values.shippingStateId && stateOptions.length > 0) {
                    formik.setFieldValue("shippingStateId", stateOptions[0].value);
                }
                //formik.setFieldValue('billingStateId', stateOptions[0]?.stateId)
                setStates(stateOptions);
            }
            else {
                setStates([]);
            }
        } catch (error) {
            handleNotify("Error fetching states:", error, TOASTER_TYPE.ERROR, TOASTER_POSITION.TOP_RIGHT)
        }
    };

    useEffect(() => {
        fetchCountry();
        fetchStates();
    }, []);

    // useEffect(() => {
    //     const fetchCompanyData = async () => {
    //         try {
    //             const response = await CompanyService.getCompanyById();
    //             if (response) {
    //                 formik.setValues({
    //                     companyName: response?.companyName,
    //                     GSTNo: response?.GSTNo,
    //                     panCard: response?.panCard,
    //                     phoneNumber: response?.phoneNumber,
    //                     billingAddressId: response?.billingAddressId,
    //                     shippingAddressId: response?.shippingAddressId,
    //                     billingAddressLine1: response?.billingAddressLine1,
    //                     billingCity: response?.billingCity,
    //                     billingStateId: response?.billingStateId,
    //                     billingPincode: response?.billingPincode,
    //                     billingCountryId: response?.billingCountryId,
    //                     billingCurrencyId: response?.billingCurrencyId,
    //                     shippingAddressLine1: response?.shippingAddressLine1,
    //                     shippingCity: response?.shippingCity,
    //                     shippingStateId: response?.shippingStateId,
    //                     shippingPincode: response?.shippingPincode,
    //                     shippingCountryId: response?.shippingCountryId,
    //                     shippingCurrencyId: response?.shippingCurrencyId,
    //                     aboutCompany: response?.aboutCompany,
    //                     favicon: response?.favicon,
    //                     logo: response?.logo,
    //                 });
    //             }
    //         }
    //         catch (error) {
    //             console.log('Error fetching Company data', error)
    //         }
    //     }
    //     fetchCompanyData();
    // }, []);

    const handleBackClick = () => {
        navigate('/dashboard');
    };

    // const base64ToBuffer = (base64) =>{
    //     if(!base64){
    //         return null;
    //     }
    //     //decode the base64 to binary
    //     const binaryString = atob(base64.split(',')[1]);
    //     const length = binaryString.length;
    //     const bytes = new Uint8Array(length);

    //     //file the Uint8Array with the byte values
    //     for(let i=0; i < length; i++){
    //         bytes[i] = binaryString.charCodeAt(i);
    //     }

    //     return bytes; //returns the Uint8Array buffer
    // };

    const handleFaviconFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setSelectedFaviconImage(URL.createObjectURL(file));
            formik.setFieldValue('favicon', file);
            formik.setFieldValue('faviconfilename', file.name);

            const reader = new FileReader();
            reader.onloadend = () => {
                setPreviewFaviconUrl(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleLogoFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setSelectedLogoImage(URL.createObjectURL(file));
            formik.setFieldValue('logo', file);
            formik.setFieldValue('logofilename', file.name);

            const reader = new FileReader();
            reader.onloadend = () => {
                setPreviewLogoUrl(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const currencyEnumOptions = CURRENCY_ENUM.map(group => ({
        value: group.currencyId, //change as id for send as id
        label: group.shortName,
    }));

    // const stateIdOptions = states.map(state => ({
    //     value: state.stateId, //change as id for send as id
    //     label: state.stateName,
    // }));

    // const countryIdOptions = countries.map(country => ({
    //     value: country.countryId, //change as id for send as id
    //     label: country.countryName,
    // }));

    return (
        <>
            <div className="page-wrapper m-0 p-4">
                <div className="page-content">
                    <div className="page-breadcrumb d-flex align-items-center mb-3">
                        <div className="breadcrumb-title pe-3 text-primary fw-bold fs-4">Company</div>
                        {/* <div className="ps-3">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb mb-0 p-0">
                                    <li className="breadcrumb-item active" aria-current="page">
                                        Company
                                    </li>
                                </ol>
                            </nav>
                        </div> */}
                        <div className="ms-auto">
                            <button
                                type="button"
                                className="btn btn-outline-secondary me-2 px-4 py-2 rounded-3 shadow-sm hover-effect"
                                onClick={handleBackClick}
                            >
                                Back
                            </button>
                        </div>
                    </div>

                    <div className="row">
                        <div className="card radius-10 border-top border-0 border-4 border-primary">
                            <div className="card-body p-4">
                                <form onSubmit={formik.handleSubmit} className="row mt-4">
                                    <div className="row">
                                        <div className="mb-3">
                                            <div className="row">
                                                <div className="col-12 col-lg-6 col-md-4 mb-3">
                                                    <label htmlFor="companyName" className="form-label d-flex">
                                                        Company Name <span className="text-danger">*</span>:
                                                    </label>
                                                    <input
                                                        type="text"
                                                        id="companyName"
                                                        name="companyName"
                                                        className={`form-control ${formik.touched.companyName && formik.errors.companyName ? 'is-invalid' : ''}`}
                                                        placeholder="Enter Company Name"
                                                        value={formik.values.companyName}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                    />
                                                    {formik.touched.companyName && formik.errors.companyName && (
                                                        <div className="invalid-feedback d-flex">{formik.errors.companyName}</div>
                                                    )}
                                                </div>

                                                <div className="col-12 col-lg-6 col-md-4 mb-3">
                                                    <label htmlFor="GSTNo" className="form-label d-flex">
                                                        GST No :
                                                    </label>
                                                    <input
                                                        type="text"
                                                        id="GSTNo"
                                                        name="GSTNo"
                                                        className="form-control"
                                                        placeholder="Enter GSTNo"
                                                        value={formik.values.GSTNo}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                    />
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-12 col-lg-6 col-md-4 mb-3">
                                                    <label htmlFor="panCard" className="form-label d-flex">
                                                        Pan Card :
                                                    </label>
                                                    <input
                                                        type="text"
                                                        id="panCard"
                                                        name="panCard"
                                                        className="form-control"
                                                        placeholder="Enter Pancard no"
                                                        value={formik.values.panCard}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                    />
                                                </div>

                                                <div className="col-12 col-lg-6 col-md-4 mb-3">
                                                    <label htmlFor="phoneNumber" className="form-label d-flex">
                                                        Phone Number<span className="text-danger">*</span>:
                                                    </label>
                                                    <input
                                                        type="text"
                                                        name="phoneNumber"
                                                        id="phoneNumber"
                                                        className={`form-control ${formik.touched.phoneNumber && formik.errors.phoneNumber ? 'is-invalid' : ''}`}
                                                        placeholder="9778526391"
                                                        value={formik.values.phoneNumber}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                    />
                                                    {formik.touched.phoneNumber && formik.errors.phoneNumber && (
                                                        <div className="invalid-feedback d-flex">{formik.errors.phoneNumber}</div>
                                                    )}
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-12 col-lg-6 col-md-4 mb-3">
                                                    <label htmlFor="mobile" className="form-label d-flex">
                                                        Mobile :
                                                    </label>
                                                    <input
                                                        type="text"
                                                        id="mobile"
                                                        name="mobile"
                                                        className="form-control"
                                                        placeholder="Enter Mobile Number"
                                                        value={formik.values.mobile}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                    />
                                                </div>

                                                <div className="col-12 col-lg-6 col-md-4 mb-3">
                                                    <label htmlFor="email" className="form-label d-flex">
                                                        Email :
                                                    </label>
                                                    <input
                                                        type="text"
                                                        id="email"
                                                        name="email"
                                                        className="form-control"
                                                        placeholder="Enter email"
                                                        value={formik.values.email}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                    />
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-12 col-lg-6 col-md-4 mb-3">
                                                    <label htmlFor="website" className="form-label d-flex">
                                                        Website :
                                                    </label>
                                                    <input
                                                        type="text"
                                                        id="website"
                                                        name="website"
                                                        className="form-control"
                                                        placeholder="Enter website"
                                                        value={formik.values.website}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row mt-2">
                                                <div className="col-12 col-lg-6 col-md-4">
                                                    <div className="card p-4">
                                                        <div>
                                                            <label htmlFor="billingAddressLine1" className="form-label d-flex">
                                                                <strong> Billing Address :</strong>
                                                            </label>
                                                            <textarea
                                                                type="text"
                                                                id="billingAddressLine1"
                                                                name="billingAddressLine1"
                                                                className={`form-control ${formik.touched.billingAddressLine1 && formik.errors.billingAddressLine1 ? 'is-invalid' : ''}`}
                                                                placeholder="Enter billing address"
                                                                value={formik.values.billingAddressLine1}
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                            />
                                                            {formik.touched.billingAddressLine1 && formik.errors.billingAddressLine1 && (
                                                                <div className="invalid-feedback d-flex">{formik.errors.billingAddressLine1}</div>
                                                            )}
                                                        </div>

                                                        <div className="row mt-3">
                                                            <div className="col-12 col-lg-6 col-md-4 mb-3">
                                                                <label htmlFor="billingPincode" className="form-label d-flex">
                                                                    Pincode :
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    id="billingPincode"
                                                                    name="billingPincode"
                                                                    className={`form-control ${formik.touched.billingPincode && formik.errors.billingPincode ? 'is-invalid' : ''}`}
                                                                    placeholder="Enter billing pincode"
                                                                    value={formik.values.billingPincode}
                                                                    onChange={formik.handleChange}
                                                                    onBlur={formik.handleBlur}
                                                                />
                                                                {formik.touched.billingPincode && formik.errors.billingPincode && (
                                                                    <div className="invalid-feedback d-flex">{formik.errors.billingPincode}</div>
                                                                )}
                                                            </div>
                                                            <div className="col-12 col-lg-6 col-md-4 mb-3">
                                                                <label htmlFor="billingCurrencyId" className="form-label d-flex">
                                                                    Currency:
                                                                </label>
                                                                <div className="text-start">
                                                                    <Select
                                                                        id="billingCurrencyId"
                                                                        name="billingCurrencyId"
                                                                        options={currencyEnumOptions}
                                                                        value={currencyEnumOptions.find(option => option.value === formik.values.billingCurrencyId)}
                                                                        onChange={(selectedOption) => formik.setFieldValue('billingCurrencyId', selectedOption.value)}
                                                                        menuPortalTarget={document.body}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="row">
                                                            <div className="col-12 col-lg-6 col-md-4 mb-3">
                                                                <label htmlFor="billingCity" className="form-label d-flex">
                                                                    City :
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    id="billingCity"
                                                                    name="billingCity"
                                                                    className="form-control"
                                                                    placeholder="Enter billing city"
                                                                    value={formik.values.billingCity}
                                                                    onChange={formik.handleChange}
                                                                    onBlur={formik.handleBlur}
                                                                />
                                                            </div>

                                                            <div className="col-12 col-lg-6 col-md-4 mb-3">
                                                                <label htmlFor="billingStateId" className="form-label d-flex">
                                                                    State:
                                                                </label>
                                                                <div className="text-start">
                                                                    <Select
                                                                        id="billingStateId"
                                                                        name="billingStateId"
                                                                        options={states}
                                                                        value={states.find(option => option.value === formik.values.billingStateId)}
                                                                        onChange={(selectedOption) => formik.setFieldValue('billingStateId', selectedOption.value)}
                                                                        menuPortalTarget={document.body}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="col-12 col-lg-6 col-md-4">
                                                            <label htmlFor="billingCountryId" className="form-label d-flex">
                                                                Country:
                                                            </label>
                                                            <div className="text-start">
                                                                <Select
                                                                    id="billingCountryId"
                                                                    name="billingCountryId"
                                                                    options={countries}
                                                                    value={countries.find(option => option.value === formik.values.billingCountryId)}
                                                                    onChange={(selectedOption) => formik.setFieldValue('billingCountryId', selectedOption.value)}
                                                                    menuPortalTarget={document.body}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-12 col-lg-6 col-md-4">
                                                    <div className="card p-4">
                                                        <div>
                                                            <label htmlFor="shippingAddressLine1" className="form-label d-flex">
                                                                <strong>Shipping Address : </strong>
                                                            </label>
                                                            <textarea
                                                                type="text"
                                                                id="shippingAddressLine1"
                                                                className={`form-control ${formik.touched.shippingAddressLine1 && formik.errors.shippingAddressLine1 ? 'is-invalid' : ''}`}
                                                                placeholder="Enter shipping address"
                                                                value={formik.values.shippingAddressLine1}
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                            />
                                                            {formik.touched.shippingAddressLine1 && formik.errors.shippingAddressLine1 && (
                                                                <div className="invalid-feedback d-flex">{formik.errors.shippingAddressLine1}</div>
                                                            )}
                                                        </div>

                                                        <div className="row mt-3">
                                                            <div className="col-12 col-lg-6 col-md-4 mb-3">
                                                                <label htmlFor="shippingPincode" className="form-label d-flex">
                                                                    Pincode :
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    name="shippingPincode"
                                                                    id="shippingPincode"
                                                                    className={`form-control ${formik.touched.shippingPincode && formik.errors.shippingPincode ? 'is-invalid' : ''}`}
                                                                    placeholder="Enter shipping pincode"
                                                                    value={formik.values.shippingPincode}
                                                                    onChange={formik.handleChange}
                                                                    onBlur={formik.handleBlur}
                                                                />
                                                                {formik.touched.shippingPincode && formik.errors.shippingPincode && (
                                                                    <div className="invalid-feedback d-flex">{formik.errors.shippingPincode}</div>
                                                                )}
                                                            </div>

                                                            <div className="col-12 col-lg-6 col-md-4 mb-3">
                                                                <label htmlFor="shippingCurrencyId" className="form-label d-flex">
                                                                    Currency:
                                                                </label>
                                                                <div className="text-start">
                                                                    <Select
                                                                        id="shippingCurrencyId"
                                                                        name="shippingCurrencyId"
                                                                        options={currencyEnumOptions}
                                                                        value={currencyEnumOptions.find(option => option.value === formik.values.shippingCurrencyId)}
                                                                        onChange={(selectedOption) => formik.setFieldValue('shippingCurrencyId', selectedOption.value)}
                                                                        menuPortalTarget={document.body}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="row">
                                                            <div className="col-12 col-lg-6 col-md-4 mb-3">
                                                                <label htmlFor="shippingCity" className="form-label d-flex">
                                                                    City :
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    id="shippingCity"
                                                                    className="form-control"
                                                                    placeholder="Enter shipping city"
                                                                    value={formik.values.shippingCity}
                                                                    onChange={formik.handleChange}
                                                                    onBlur={formik.handleBlur}
                                                                />
                                                            </div>

                                                            <div className="col-12 col-lg-6 col-md-4 mb-3">
                                                                <label htmlFor="shippingStateId" className="form-label d-flex">
                                                                    State:
                                                                </label>
                                                                <div className="text-start">
                                                                    <Select
                                                                        id="shippingStateId"
                                                                        name="shippingStateId"
                                                                        options={states}
                                                                        value={states.find(option => option.value === formik.values.shippingStateId)}
                                                                        onChange={(selectedOption) => formik.setFieldValue('shippingStateId', selectedOption.value)}
                                                                        menuPortalTarget={document.body}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="col-12 col-lg-6 col-md-4">
                                                            <label htmlFor="shippingCountryId" className="form-label d-flex">
                                                                Country:
                                                            </label>
                                                            <div className="text-start">
                                                                <Select
                                                                    id="shippingCountryId"
                                                                    name="shippingCountryId"
                                                                    options={countries}
                                                                    value={countries.find(option => option.value === formik.values.shippingCountryId)}
                                                                    onChange={(selectedOption) => formik.setFieldValue('shippingCountryId', selectedOption.value)}
                                                                    menuPortalTarget={document.body}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row mt-2">
                                                <div className="col-12">
                                                    <label htmlFor="aboutCompany" className="form-label d-flex">
                                                        About Company :
                                                    </label>
                                                    <Editor
                                                        value={formik.values.aboutCompany}
                                                        tinymceScriptSrc={`${process.env.PUBLIC_URL}/tinymce/tinymce.min.js`}
                                                        init={{
                                                            height: 300,
                                                            menubar: true,
                                                            plugins: [
                                                                "advlist autolink lists link image charmap print preview anchor",
                                                                "searchreplace visualblocks code fullscreen",
                                                                "insertdatetime media table paste code help wordcount",
                                                            ],
                                                            toolbar:
                                                                "undo redo | formatselect | bold italic backcolor | \
                                                                alignleft aligncenter alignright | bullist numlist outdent indent | \
                                                                link image",
                                                        }}
                                                        onEditorChange={(content) =>
                                                            formik.setFieldValue("aboutCompany", content)
                                                        }
                                                    />
                                                </div>
                                            </div>

                                            <div className="row mt-3">
                                                <div className="col-12 col-lg-6 col-md-4 mb-3">
                                                    <label htmlFor="favicon" className="form-label d-flex">
                                                        Favicon :
                                                    </label>
                                                    <input
                                                        type="file"
                                                        id="favicon"
                                                        name="favicon"
                                                        className="form-control"
                                                        accept="image/*"
                                                        onChange={handleFaviconFileChange}
                                                    />

                                                    {previewFaviconUrl && (
                                                        <div
                                                            style={{
                                                                width: '100%',
                                                                height: '400px',
                                                                border: '1px solid #ddd',
                                                                display: 'flex',
                                                                justifyContent: 'center',
                                                                alignItems: 'center',
                                                                position: 'relative',
                                                                backgroundColor: '#f8f8f8',
                                                            }}
                                                        >
                                                            <img
                                                                src={previewFaviconUrl}
                                                                alt="Preview"
                                                                style={{
                                                                    width: '100%',
                                                                    height: '100%',
                                                                    objectFit: 'cover',
                                                                }}
                                                            />
                                                        </div>
                                                    )}

                                                    {!previewFaviconUrl && (
                                                        <div
                                                            style={{
                                                                width: '100%',
                                                                height: '300px',
                                                                display: 'flex',
                                                                justifyContent: 'center',
                                                                alignItems: 'center',
                                                                border: '1px dashed #bbb',
                                                                backgroundColor: '#f8f8f8',
                                                                fontSize: '14px',
                                                                color: '#888',
                                                            }}
                                                        >
                                                            <span>Upload Image</span>
                                                        </div>
                                                    )}

                                                    {selectedFaviconImage && (
                                                        <div>
                                                            <p>File Name: {selectedFaviconImage.name}</p>
                                                            {/* <p>File Size: {Math.round(selectedImage.size / 1024)} KB</p> */}
                                                        </div>
                                                    )}
                                                </div>

                                                <div className="col-12 col-lg-6 col-md-4 mb-3">
                                                    <label htmlFor="logo" className="form-label d-flex">
                                                        Logo :
                                                    </label>
                                                    <input
                                                        type="file"
                                                        id="logo"
                                                        name="logo"
                                                        className="form-control"
                                                        accept="image/*"
                                                        onChange={handleLogoFileChange}
                                                    />

                                                    {previewLogoUrl && (
                                                        <div
                                                            style={{
                                                                width: '100%',
                                                                height: '200px',
                                                                border: '1px solid #ddd',
                                                                display: 'flex',
                                                                justifyContent: 'center',
                                                                alignItems: 'center',
                                                                position: 'relative',
                                                                backgroundColor: '#f8f8f8',
                                                            }}
                                                        >
                                                            <img
                                                                src={previewLogoUrl}
                                                                alt="Preview"
                                                                style={{
                                                                    width: '100%',
                                                                    height: '100%',
                                                                    objectFit: 'cover',
                                                                }}
                                                            />
                                                        </div>
                                                    )}

                                                    {!previewLogoUrl && (
                                                        <div
                                                            style={{
                                                                width: '100%',
                                                                height: '300px',
                                                                display: 'flex',
                                                                justifyContent: 'center',
                                                                alignItems: 'center',
                                                                border: '1px dashed #bbbbbb',
                                                                backgroundColor: '#f8f8f8',
                                                                fontSize: '14px',
                                                                color: '#888',
                                                            }}
                                                        >
                                                            <span>Upload Image</span>
                                                        </div>
                                                    )}

                                                    {selectedLogoImage && (
                                                        <div>
                                                            <p>File Name: {selectedLogoImage.name}</p>
                                                            {/* <p>File Size: {Math.round(selectedImage.size / 1024)} KB</p> */}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                            <hr />
                                            <div className="d-flex flex-column flex-md-row mt-4 justify-content-end">
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-secondary mb-2 mb-md-0 me-2 px-4 py-2 rounded-3 shadow-sm hover-effect"
                                                    onClick={handleBackClick}
                                                >
                                                    Back
                                                </button>
                                                <button
                                                    type="submit"
                                                    className="btn btn-primary px-4 py-2 rounded-3 shadow-sm hover-effect"
                                                >
                                                    Save
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CompanyComponent;
